import client from "./client";
import { prepareProductPage } from "./productpage";

export const prepareProductPageTwo = prepareProductPage;

export const getProductPageTwo = () => client.post("/productpagetwo/getPage");
export const addProductPageTwo = (payload) =>
  client.post("/productpagetwo/addpage", payload);
export const updateProductPageTwo = (payload) =>
  client.post("/productpagetwo/updatePage", payload);
